import { Flame } from "lucide-react";

const ITEMS = [
  "Love Everyone",
  "Serve Everyone",
  "Feed Everyone",
  "Remember God",
  "Sub Ek — All is One",
  "Jai Shri Ram",
  "Jai Hanuman",
  "Sita Ram Sita Ram",
];

export default function Marquee() {
  return (
    <div
      data-testid="mantra-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-amber-900/10 bg-[#F5F0E6] py-5 sm:py-6 select-none"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {ITEMS.map((t) => (
              <span key={`${t}-${half}`} className="flex items-center shrink-0">
                <span className="font-display text-lg sm:text-2xl text-amber-900/60 tracking-wide px-6 sm:px-10 whitespace-nowrap">
                  {t}
                </span>
                <Flame className="h-3.5 w-3.5 text-orange-600/50 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
